import type { IRoleEnum } from "@/interfaces";
import type { IExtendedRouteObject } from "@routes/types.ts";
import { isMobileApp } from "@utils";

export const getRoleRoutes = (
  role: IRoleEnum | null,
  routes: IExtendedRouteObject[],
) => {
  return routes
    ?.filter(
      (route) =>
        (role === null ||
          (route.permissions === "all"
            ? true
            : route.permissions?.includes(role)) ||
          route.route.path === "/") &&
        !getNoUserValue(route.noUser),
    )
    ?.map((route) => route.route);
};

export const getOutsideLayoutRoutes = (routes: IExtendedRouteObject[]) => {
  return routes
    ?.filter((route) => getNoUserValue(route.noUser))
    ?.map((route) => route.route);
};

const getNoUserValue = (noUser?: boolean) => {
  if (isMobileApp) {
    return noUser;
  }
  return false;
};
